import React, { useState } from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import Image from "../../Image";
import { Link } from "../../LinkComponent";
import Button from "../../NewForms/Button";
import SmallShapeContainer from "../../SmallShapeContainer";

const GridContainer = styled.div`
    display: grid;
    column-gap: 20px;
    row-gap: 50px;
    margin-top: 30px;
    grid-template-columns: repeat(1, 1fr);
    justify-content: space-between;
    ${({ theme }) => theme.breakpoints.from.small.css`
       grid-template-columns: repeat(2, 1fr);
       justify-content: space-around;
    `}
    ${({ theme }) => theme.breakpoints.from.normal.css`
       grid-template-columns: repeat(4, 1fr);
       justify-content: space-between;
    `}
    ${({ theme }) => css`
        ${theme.paddings.containerOuter.right}
        ${theme.paddings.containerOuter.left}
    `}
`;

const Card = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 260px;
    margin: 0 auto;
    overflow: hidden;
`;

const Headline = styled.span`
    ${(props) => (props.hasMarginBottom ? "margin-bottom: 20px;" : "")}

    font-weight: bold;
    font-size: 18px;
`;

const LinkText = styled.span`
    font-weight: bold;
    text-decoration: underline;
    ${({ theme }) => css`
        color: ${theme.colors.red.toString()};
    `}
`;

const applyBold = (item) => {
    return item.isBold
        ? css`
              font-weight: bold;
          `
        : "";
};

const ActionRow = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 50px;
    ${({ theme }) => theme.breakpoints.from.medium.css`
        display: none;
    `}
`;

const SimCards = ({ items, mobileOnlyThree }) => {
    const theme = useTheme();
    const [isOpen, setIsOpen] = useState(false);

    const mobileHidden = css`
        display: none;
        ${theme.breakpoints.from.medium.css`
             display: flex;
        `}
    `;

    return (
        <>
            <GridContainer>
                {items.map((element, index) => (
                    <SimCard
                        key={index}
                        css={
                            index >= 3 &&
                            !isOpen &&
                            mobileOnlyThree &&
                            mobileHidden
                        }
                        {...element}
                    />
                ))}
            </GridContainer>
            {mobileOnlyThree && (
                <ActionRow>
                    <Button onClick={() => setIsOpen(!isOpen)}>
                        {isOpen ? "Weniger Anzeigen" : "Alle Anzeigen"}
                    </Button>
                </ActionRow>
            )}
        </>
    );
};

const SimCard = ({
    image,
    headline,
    subline,
    row1,
    row2,
    linkOptional,
    ...rest
}) => {
    return (
        <Card {...rest}>
            <SmallShapeContainer
                css={css`
                    margin: 0 auto;
                `}
            >
                <SmallShapeContainer.ImageContainer>
                    {!image.isIcon && <ImageImage image={image.image} />}
                    {image.isIcon && <IconImage image={image.image} />}
                </SmallShapeContainer.ImageContainer>

                <SmallShapeContainer.TextContainer>
                    {headline && (
                        <Headline hasMarginBottom={headline.hasMarginBottom}>
                            {headline.text}
                        </Headline>
                    )}
                    {subline.text && (
                        <span css={applyBold(subline)}>{subline.text}</span>
                    )}
                    {row1.text && (
                        <span css={applyBold(row1)}>{row1.text}</span>
                    )}
                    {row2.text && (
                        <span css={applyBold(row2)}>{row2.text}</span>
                    )}

                    {linkOptional.href && linkOptional.text && (
                        <Link to={linkOptional.href}>
                            <LinkText>{linkOptional.text}</LinkText>
                        </Link>
                    )}
                </SmallShapeContainer.TextContainer>
            </SmallShapeContainer>
        </Card>
    );
};

const IconImageContainer = styled.div`
    height: 150px;
    padding: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Img = styled(Image)`
    max-width: 100%;
    height: 100%;
    object-fit: contain;
`;

const IconImage = ({ image }) => {
    return (
        <IconImageContainer>
            <Img src={image.src} alt={image.alt} title={image.title} />
        </IconImageContainer>
    );
};

const ImageImageContainer = styled.div`
    height: 150px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
`;

const ImageImage = ({ image }) => {
    return (
        <ImageImageContainer
            css={css`
                background-image: url("${image.src.publicURL}");
            `}
        ></ImageImageContainer>
    );
};

export default SimCards;
